import { memo } from "react";
import { Chip, Image, lightenColor, PageHeader, useTheme, type DivProps, type OmitProps } from "react-better-html";

import { formatPrice } from "../../utils/functions";
import { useI18n } from "../../utils/i18n";

import DecorationCard from "./DecorationCard";

type DecorationPropertyCardProps = OmitProps<DivProps, "children"> & {};

function DecorationPropertyCard({ ...props }: DecorationPropertyCardProps) {
   const theme = useTheme();
   const { t } = useI18n();

   return (
      <DecorationCard width={230} {...props}>
         <Image
            name="interior01"
            width="100%"
            height={70}
            objectFit="cover"
            borderRadius={theme.styles.borderRadius / 2}
            marginBottom={theme.styles.gap}
         />

         <PageHeader
            title={formatPrice(148_500, "EUR")}
            titleAs="h4"
            description={t((l) => l.components.decorations.property.address)}
            descriptionFontSize={12}
            rightElement={
               <Chip
                  text="-4.2%"
                  fontSize={10}
                  fontWeight={700}
                  color={theme.colors.success}
                  backgroundColor={lightenColor(theme.colors.success, 0.85)}
               />
            }
            marginBottom={0}
         />
      </DecorationCard>
   );
}

export default memo(DecorationPropertyCard);
